export const basePath =
  process.env.NEXT_PUBLIC_BASE_PATH || process.env.BASE_PATH || "";
